import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** shadcn/ui's class merge helper. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

/**
 * Formatting moved to `@/lib/format` when multilingual support landed.
 * It needs the active locale and translator, which this module — imported
 * by every component — must not depend on.
 */
